//
import Model from "@/models/Model"

/**
 * 
 */
export default class ARun extends Model {

    /**
     * @description
     */
    resource () {
        return "run"
    }
}